/**
 * Initial state for rooms reducer
 */
export const initialState = {
    id: false,
};

/**
 * Retrieves room data from local storage if present. Used by useReducer() in
 * RoomsProvider as initializer.
 *
 * @see useReducer
 *
 * @param {Object} initialValue
 * @returns Initial state for reducer
 */
export const initializer = (initialValue = initialState) =>
    JSON.parse(localStorage.getItem("localRoom")) || initialValue;

/**
 * Reducer for actions related to room data in RoomsProvider. Used by
 * useReducer() in RoomsProvider as reducer function.
 *
 * @param {Object} state
 * @param {Object} action
 * @returns Reducer function
 */
export const roomsReducer = (state, action) => {
    switch (action.type) {
        case "SET_ROOM":
            return action.payload.rooms.docs.find(
                (room) => room.id === action.payload.id
            ) !== undefined
                ? { ...state, id: action.payload.id }
                : state;
        case "SET_ROOM_BY_ACCESS_CODE":
            const roomWithAccessCode = action.payload.rooms.docs.find(
                (room) => {
                    const roomData = room.data();
                    return roomData.accessCode === action.payload.accessCode;
                }
            );

            return roomWithAccessCode !== undefined
                ? { ...state, id: roomWithAccessCode.id }
                : state;
        case "CLEAR_ROOM":
            return { ...state, id: false };
        default:
            throw new Error();
    }
};

/**
 * Formatting function for roomsReducer. Sets room in state by ID.
 *
 * @see roomsReducer
 *
 * @param {string} id
 * @param {Object} rooms
 * @returns Action object
 */
export const setRoom = (id, rooms) => ({
    type: "SET_ROOM",
    payload: { id, rooms },
});

/**
 * Formatting function for roomsReducer. Sets room in state by access code.
 *
 * @see roomsReducer
 *
 * @param {string} id
 * @param {Object} rooms
 * @returns Action object
 */
export const setRoomByAccessCode = (accessCode, rooms) => ({
    type: "SET_ROOM_BY_ACCESS_CODE",
    payload: { accessCode, rooms },
});

/**
 * Formatting function for roomsReducer. Clears room state.
 *
 * @see roomsReducer
 *
 * @param {string} id
 * @param {Object} rooms
 * @returns Action object
 */
export const clearRoom = () => ({
    type: "CLEAR_ROOM",
});
